import { render, staticRenderFns } from "./drugRemarkModal.vue?vue&type=template&id=1c3e4e9c&scoped=true"
import script from "./drugRemarkModal.vue?vue&type=script&lang=js"
export * from "./drugRemarkModal.vue?vue&type=script&lang=js"
import style0 from "./drugRemarkModal.vue?vue&type=style&index=0&id=1c3e4e9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3e4e9c",
  null
  
)

export default component.exports